module.exports = __webpack_public_path__ + "img/new_unactive_04.a6aa5264.jpg";